/* eslint-disable */

import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { LicenseAccessBadge } from '../ProductCategoryLicense';
import { formatCustomAccessLabel } from './licenseFormUtils';

export const ACCESS_OPTIONS = [
  { value: 'buy-sell', label: 'ซื้อ+ขาย' },
  { value: 'buy-only', label: 'ซื้อเท่านั้น' },
  { value: 'sell-only', label: 'ขายเท่านั้น' },
  { value: 'none', label: '—' },
];

export function LicenseAccessSelect({ value, onChange, customCount = 0 }) {
  const [open, setOpen] = useState(false);
  const selected = ACCESS_OPTIONS.find((option) => option.value === value) || ACCESS_OPTIONS[3];
  const isCustom = customCount > 0;
  const displayLabel = isCustom ? formatCustomAccessLabel(customCount) : selected.label;
  const displayClass = isCustom ? 'custom' : selected.value;

  return (
    <Dropdown
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
      overlayClassName='license-form-access-dropdown'
      menu={{
        selectable: true,
        selectedKeys: [value],
        onClick: ({ key }) => {
          onChange(key);
          setOpen(false);
        },
        items: ACCESS_OPTIONS.map((option) => ({
          key: option.value,
          label: <LicenseAccessBadge type={option.value} />,
        })),
      }}
    >
      <button
        type='button'
        className={`license-form-access-select${open ? ' license-form-access-select--open' : ''}`}
      >
        <span className={`license-form-access-pill license-form-access-pill--${displayClass}`}>
          {displayLabel}
        </span>
        <span className='license-form-access-chevron-wrap' aria-hidden='true'>
          <span className='license-form-access-chevron' />
        </span>
      </button>
    </Dropdown>
  );
}
